import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Block from 'components/structure/Block/Block';
import ImageBlock from 'components/structure/ImageBlock';
import Section from 'components/structure/Section';

function SectionKnowMore() {
  return (
    <Section
      backgroundColor="white.dark"
      contained
    >
      <FormattedMessage id="REWARDS.KNOW_MORE.IMAGE_ALT">
        {([alt]) => (
          <ImageBlock
            alt={alt}
            loading="lazy"
            imageWidth="100%"
            imageHeight="100%"
            backgroundImage="rewards-illustration/rewards-illustration.png"
            noPadding
          />
        )}
      </FormattedMessage>

      <Block backgroundColor="white" mobileOrder={3}>
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          intlKey="REWARDS.KNOW_MORE.TITLE"
        />

        <FormattedMessage id="REWARDS.KNOW_MORE.BUTTON.LINK">
          {([link]) => (
            <Link
              target="_blank"
              href={link}
              color="primary"
              intlKey="REWARDS.KNOW_MORE.BUTTON.TEXT"
              rel="noopener"
              variant="action"
            />
          )}
        </FormattedMessage>
      </Block>
    </Section>
  );
}

export default React.memo(SectionKnowMore);
